import './StatusButton.css'
const StatusButton = ({status}) => {
    return ( 
        <button className="btn btn-outline-dark status_button">
        {status}
      </button>
     );
}
 
export default StatusButton;